import React from "react";
import { Badge, Button } from "reactstrap";
//Icons
import EditIcon from "react-icons/lib/md/edit";
import CheckIcon from "react-icons/lib/md/check";
import ClearIcon from "react-icons/lib/md/clear";

import ToolTipItem from "../utils/tooltip";
import { Table, Th, Thead, Tr, Td } from "reactable";
import DownloadIcon from "react-icons/lib/md/cloud-download";

class AirlineTable extends React.Component {
  render() {
    let { data, editCallback, handleAirlinesDownload } = this.props;
    return (
      <div>
        <div className="d-flex justify-content-start mb-3">
          <Button
            className="btn btn-avi-secondary"
            onClick={handleAirlinesDownload}
          >
            <DownloadIcon /> Download
          </Button>
        </div>

        <Table
          className="table table-striped table-hover"
          id="table"
          sortable={true}
          itemsPerPage={15}
          pageButtonLimit={10}
        >
          <Thead>
            <Th column="Name">
              <span>Name</span>
            </Th>
            <Th column="Code">
              <span>Airline Code</span>
            </Th>
            <Th column="ShortName">
              <span>Short Name</span>
            </Th>
            <Th column="AviationCode">
              <span>Aviation Code</span>
            </Th>
            <Th column="TicketFormat">
              <span>Ticket Format</span>
            </Th>
            <Th column="AirlineSisId">
              <span>SSID</span>
            </Th>
            <Th column="AirlineType">
              <span>Airline Type</span>
            </Th>
            {/* <Th column="ExpectedMinPax">
                            <span>Expected Min. Passengers</span>
                        </Th>
                        <Th column="ExpectedMaxPax">
                            <span>Expected Max. Passengers</span>
                        </Th>
                        <Th column="ExpectedMinFlights">
                            <span>Expected Min. Flights</span>
                        </Th>
                        <Th column="ExpectedMaxFlights">
                            <span>Expected Max. Flights</span>
                        </Th> */}
            <Th column="Carrier">
              <span>Carrier</span>
            </Th>
            <Th column="Action">Action</Th>
          </Thead>

          {data.map((item, i) => (
            <Tr key={i}>
              <Td column="Name" className="text-capitalize">
                {item.Name}
              </Td>
              <Td column="Code">{item.Code}</Td>
              <Td column="ShortName" className="text-capitalize">
                {item.ShortName}
              </Td>
              <Td column="AviationCode">{item.AviationCode}</Td>
              <Td column="TicketFormat" className="text-capitalize">
                {item.TicketFormat}
              </Td>
              <Td column="AirlineSisId">{item.AirlineSisId}</Td>
              <Td column="AirlineType" value={item.IsLocal}>
                <span>
                  {item.IsLocal && (
                    <Badge color="warning">&nbsp;Local&nbsp;</Badge>
                  )}
                  {!item.IsLocal && (
                    <Badge color="success">
                      &nbsp;&nbsp;International&nbsp;&nbsp;
                    </Badge>
                  )}
                </span>
              </Td>
              {/* <Td column="ExpectedMinPax">{item.ExpectedMinPax}</Td>
                        <Td column="ExpectedMaxPax">{item.ExpectedMaxPax}</Td>
                        <Td column="ExpectedMinFlights">{item.ExpectedMinFlights}</Td>
                        <Td column="ExpectedMaxFlights">{item.ExpectedMaxFlights}</Td> */}

              <Td column="Carrier" value={item.Carrier}>
                <span>
                  {item.Carrier && <CheckIcon color="#43a8df" />}
                  {!item.Carrier && <ClearIcon color="#43a8df" />}
                </span>
              </Td>
              <Td column="Action">
                <span
                  className="text-primary pointer"
                  onClick={(e) => editCallback(item)}
                >
                  <ToolTipItem
                    key={i + "edit"}
                    title={<EditIcon size="15" color="#43a8df" />}
                    content="Edit record"
                    id={i + "edit"}
                  />
                </span>
              </Td>
            </Tr>
          ))}
        </Table>
      </div>
    );
  }
}
export default AirlineTable;



// WEBPACK FOOTER //
// ./src/views/airline/airline-table.js